const KYB_FLOW_PATHS = ['/business/verification', '/login', '/login/callback', '/logout/callback'];

export const keepsKybOnlyPath = (pathname: string) =>
  KYB_FLOW_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));

export const isBusinessKybLocked = (input: {
  isBusinessLogin: boolean;
  isVerified: boolean;
  kybStatus?: string | null;
}) => {
  if (!input.isBusinessLogin) {
    return false;
  }

  if (!input.isVerified) {
    return true;
  }

  return input.kybStatus !== 'Active';
};

export const shouldConfineBusinessToKyb = (input: {
  isBusinessLogin: boolean;
  isVerified: boolean;
  kybStatus?: string | null;
  pathname: string;
}) => isBusinessKybLocked(input) && !keepsKybOnlyPath(input.pathname);

export const destinationPath = (url: string) => url.split('?')[0].split('#')[0];
